<!--
  ~ Copyright (c) 1999 - 2020 Accorto, Inc. - All rights reserved.
  -->

<section #dialog aria-describedby="float-content"
         aria-labelledby="float-heading"
         aria-modal="true"
         [ngStyle]="{'border': borderStyle, 'width': width }"
         class="slds-modal float-dialog"
         role="dialog"
         tabindex="-1">
  <div>
    <header (mousedown)="onHeaderMouseDown($event)"
            (mousemove)="onHeaderMouseMove($event)"
            (mouseup)="onHeaderMouseUp()"
            [style.cursor]="mouseOffset ? 'grabbing' : 'grab'"
            class="slds-modal__header">
      <!-- button (click)="onClose()"
              class="slds-button slds-button_icon slds-modal__close slds-button_icon-inverse"
              title="Close">
        <svg aria-hidden="true" class="slds-button__icon slds-button__icon_large">
          <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#close"></use>
        </svg>
        <span class="slds-assistive-text">Close</span>
      </button -->
      <h2 class="slds-text-heading_medium slds-hyphenate"
          id="mf-heading">
        <svg *ngIf="iconRef.includes('#')"
             aria-hidden="true" class="slds-icon slds-icon_small slds-icon-text-light">
          <use [attr.xlink:href]="iconRef"></use>
        </svg>
        <img *ngIf="iconRef.endsWith('.svg')"
             [src]="iconRef"
             [alt]="title"
             class="slds-image__icon"/>
        <span class="slds-m-left_small" id="mf-title">{{title}}</span>
      </h2>
    </header>

    <div class="slds-modal__content slds-p-horizontal_medium"
         id="mf-content"
         style="min-height: 400px">
      <ng-content>
      </ng-content>
    </div>

    <footer *ngIf="showFooter"
            class="slds-modal__footer">
      <div class="slds-button-group slds-float_left" role="group">
        <button (click)="onClose()"
                class="slds-button slds-button_neutral"
                i18n-title
                id="mf-close" title="Close" type="button">
          <svg aria-hidden="true" class="slds-button__icon slds-button__icon_left">
            <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#close"></use>
          </svg>
          <span i18n>Close</span>
        </button>
        <button (click)="onClear()" *ngIf="showClear"
                class="slds-button slds-button_neutral"
                i18n-title
                id="mf-clear" title="Clear selection" type="button">
          <svg aria-hidden="true" class="slds-button__icon slds-button__icon_left">
            <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#clear"></use>
          </svg>
          <span i18n>Clear</span>
        </button>
      </div>

      <small class="slds-m-left_small" i18n style="line-height: 2rem;">Move the window by dragging the header</small>

      <ng-content select="footerButton">
      </ng-content>
    </footer>
  </div>
</section>
<!--div class="slds-backdrop slds-backdrop_open"></div-->

